module.exports = __webpack_public_path__ + "img/menu.659a4e70.png";